module.exports = __webpack_public_path__ + "img/168197.1a03e2d2.jpg";